
import vClickOutside from 'v-click-outside';

export default {
  name: "FilterDropdownWrapper",

  directives: {
    clickOutside: vClickOutside.directive,
  },

  props: {
    filterTitle: {
      type: String,
      default: ''
    },
    filterDisplayValue: {
      type: String,
      default: ''
    },
    filterIcon: {
      type: String,
      default: '',
    },
    customSize: {
      type: String,
      default: '0',
    },
    disableScrollTop: {
      type: Boolean,
      required: false,
      default: false,
    }
  },

  data() {
    return {
      dropdownActive: false,
      icon: {
        default: this.filterIcon ? require(`@/assets/images/products/product-feature/filter-icons/${this.filterIcon}_filled.svg`) : '',
        active: this.filterIcon ? require(`@/assets/images/products/product-feature/filter-icons/${this.filterIcon}_white.svg`) : '',
      }
    }
  },
  methods: {
    toggleDropdown() {
      // console.debug('dropdown wrapper click');
      // this.dropdownActive = !this.dropdownActive;
      if ( this.dropdownActive ) {
        this.closeDropdown();
      } else {
        this.dropdownActive = true;
      }
    },
    closeDropdown() {
      if ( this.dropdownActive ) {
        this.$emit('on-close', false);
        this.dropdownActive = false;
        if ( !this.disableScrollTop ) window.scrollTo(0, 0);
      }
    }
  }
}
